import { TsrctDemandRequestLineItem } from '@/generated/gql/graphql';

export enum DemandRequestLineItemGridField {
  POSITION = 'position',
  TITLE = 'title',
  DESCRIPTION = 'description',
  MATERIAL_REFERENCE = 'materialReference',
  UNIT = 'unitId',
  QUANTITY = 'quantity',
  EXPECTED_PRICE_PER_UNIT = 'expectedPricePerUnit',
  BASELINE_PRICE_PER_UNIT = 'baselinePricePerUnit',
  PREFERRED_SUPPLIER_ID = 'preferredSupplierId',
  CONTRACT_ITEM = 'contractItemId',
  COMMODITY = 'commodityId',
  FROM = 'shipmentTerms.earlyDeliveryAt',
  TO = 'shipmentTerms.lateDeliveryAt',
  COMMODITY_GROUP_ID = 'commodityGroupId',
  ORGANIZATION = 'organizationId',
  DELIVERY_LOCATION = 'deliveryLocationId',
  READY_FOR_AUTOMATION = 'readyForAutomation',
  DELETE_ACTION = 'deleteAction',
}

export enum DemandRequestLineItemGridColumnGroup {
  REQUEST_ITEM = 'requestItem',
  DELIVERY_DATE = 'deliveryDate',
  CLASSIFICATION = 'classification',
  ACTIONS = 'actions',
}

export type DemandRequestLineItemGridRow = Omit<TsrctDemandRequestLineItem, 'updatedAt'>;
